export default __webpack_public_path__ + "static/media/151-bed-side.43a7e1ad.png";